export const HONEYPOT_FIELD_NAME = 'juridika_website'

export const TURNSTILE_TOKEN_FIELD_NAME = 'cf-turnstile-response'
